// extracted by mini-css-extract-plugin
module.exports = {"mark":"mark--9QH97","selected":"selected--sfWdQ","highlighted":"highlighted--LwFqa","relation":"relation--oijJh","delete":"delete--Sr0fU","row":"row--FlFRa"};
    if(module.hot) {
      // 1653630383269
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  